import { render } from "./Versions.vue?vue&type=template&id=260deec0&ts=true"
import script from "./Versions.vue?vue&type=script&lang=ts"
export * from "./Versions.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\Roshaw\\WebstormProjects\\random-song\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__